export default function ({ app, store, redirect }) {
  if (store.state.user.isLogged) {
    redirect(app.localePath({ name: 'checkout-index-step2' }))
  }
}
